__turbopack_context__.v({
  "line": "CompareHeading-module-scss-module__JXvCYG__line",
});
